var img = "data:image/svg+xml,%3csvg viewBox='0 0 15 22' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M0.399658 21.3499V0.649902L14.1997 10.9999L0.399658 21.3499Z' /%3e%3c/svg%3e";
  export default img;